<div class="container">
  <form [formGroup]="formGroup" (ngSubmit)="handleSubmit()">
    <app-request-title></app-request-title>

    <app-workspace-state
      [workspaceStateDraftVersion]="workspaceStateDraftVersion"
      [workspaceStateId]="workspaceStateId"
      [getWorkspaceStateToSave]="getWorkspaceStateToSave"
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
      (workspaceStateLoaded)="handleLoadWorkspaceResponse($event)"
    ></app-workspace-state>

    @let investorDetailsFormGroupAlertShouldBeVisible =
      submitted && !isInvestorDetailsFormGroupValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          investorDetailsFormGroupAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          {{
            'HOUSEHOLD_SEWAGE_TREATMENT_NOTIFICATION.CLIENT_DATA' | translate
          }}
        </div>

        <div class="card-body">
          <app-investor-details
            [investorDetailsFromGroup]="getInvestorDetailsFormGroup()"
            [isEmailRequired]="false"
            [isEPUAPAddressVisible]="true"
            [isPeselVisible]="false"
            [isIdVisible]="false"
            [isPhoneNumberRequired]="false"
            [disabledNaturalPersonData]="true"
            [wasFormValidated]="submitted"
            [loggedUserAddressEditableByExternalForm]="true"
          ></app-investor-details>
        </div>

        @if (investorDetailsFormGroupAlertShouldBeVisible) {
          <div class="card-footer">
            <div class="alert alert-danger my-2">
              {{ 'FIELDS_REQUIRED' | translate }}
            </div>
          </div>
        }
      </div>
    </section>

    @let activityDescriptionFormControlAlertShouldBeVisible =
      submitted && !isActivityDescriptionFormControlValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          activityDescriptionFormControlAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          <label class="mb-0" [attr.for]="controlName.ActivityDescription">
            {{
              'HOUSEHOLD_SEWAGE_TREATMENT_NOTIFICATION.ACTIVITY_DESCRIPTION'
                | translate
            }}
          </label>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <textarea
                [name]="controlName.ActivityDescription"
                [id]="controlName.ActivityDescription"
                class="form-control form-control-sm required"
                aria-required="true"
                [formControlName]="controlName.ActivityDescription"
              ></textarea>
            </div>
          </div>
        </div>

        @if (activityDescriptionFormControlAlertShouldBeVisible) {
          <div class="card-footer">
            <div class="alert alert-danger my-2">
              {{ 'FIELD_REQUIRED' | translate }}
            </div>
          </div>
        }
      </div>
    </section>

    @let installationOperatingTimeFormControlAlertShouldBeVisible =
      submitted && !isInstallationOperatingTimeFormControlValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          installationOperatingTimeFormControlAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          <label
            class="mb-0"
            [attr.for]="controlName.InstallationOperatingTime"
          >
            {{
              'HOUSEHOLD_SEWAGE_TREATMENT_NOTIFICATION.INSTALLATION_OPERATING_TIME'
                | translate
            }}
          </label>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <input
                type="text"
                [name]="controlName.InstallationOperatingTime"
                [id]="controlName.InstallationOperatingTime"
                class="form-control form-control-sm required"
                aria-required="true"
                [formControlName]="controlName.InstallationOperatingTime"
              />
            </div>
          </div>
        </div>

        @if (installationOperatingTimeFormControlAlertShouldBeVisible) {
          <div class="card-footer">
            <div class="alert alert-danger my-2">
              {{ 'FIELD_REQUIRED' | translate }}
            </div>
          </div>
        }
      </div>
    </section>

    @let emissionTypeAndAmountFormControlAlertShouldBeVisible =
      submitted && !isEmissionTypeAndAmountFormControlValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          emissionTypeAndAmountFormControlAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          <label class="mb-0" [attr.for]="controlName.EmissionTypeAndAmount">
            {{
              'HOUSEHOLD_SEWAGE_TREATMENT_NOTIFICATION.EMISSION_TYPE_AND_AMOUNT'
                | translate
            }}
          </label>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <textarea
                [name]="controlName.EmissionTypeAndAmount"
                [id]="controlName.EmissionTypeAndAmount"
                class="form-control form-control-sm required"
                aria-required="true"
                [formControlName]="controlName.EmissionTypeAndAmount"
              ></textarea>
            </div>
          </div>
        </div>

        @if (emissionTypeAndAmountFormControlAlertShouldBeVisible) {
          <div class="card-footer">
            <div class="alert alert-danger my-2">
              {{ 'FIELD_REQUIRED' | translate }}
            </div>
          </div>
        }
      </div>
    </section>

    @let emissionReductionMethodsFormControlAlertShouldBeVisible =
      submitted && !isEmissionReductionMethodsFormControlValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          emissionReductionMethodsFormControlAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          <label class="mb-0" [attr.for]="controlName.EmissionReductionMethods">
            {{
              'HOUSEHOLD_SEWAGE_TREATMENT_NOTIFICATION.EMISSION_REDUCTION_METHODS'
                | translate
            }}
          </label>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <textarea
                [name]="controlName.EmissionReductionMethods"
                [id]="controlName.EmissionReductionMethods"
                class="form-control form-control-sm required"
                aria-required="true"
                [formControlName]="controlName.EmissionReductionMethods"
              ></textarea>
            </div>
          </div>
        </div>

        @if (emissionReductionMethodsFormControlAlertShouldBeVisible) {
          <div class="card-footer">
            <div class="alert alert-danger my-2">
              {{ 'FIELD_REQUIRED' | translate }}
            </div>
          </div>
        }
      </div>
    </section>

    @let reductionCompliantDescriptionFormControlAlertShouldBeVisible =
      submitted && !isReductionCompliantDescriptionFormControlValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          reductionCompliantDescriptionFormControlAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          <label
            class="mb-0"
            [attr.for]="controlName.ReductionCompliantDescription"
          >
            {{
              'HOUSEHOLD_SEWAGE_TREATMENT_NOTIFICATION.REDUCTION_COMPLIANT_DESCRIPTION'
                | translate
            }}
          </label>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <textarea
                [name]="controlName.ReductionCompliantDescription"
                [id]="controlName.ReductionCompliantDescription"
                class="form-control form-control-sm required"
                aria-required="true"
                [formControlName]="controlName.ReductionCompliantDescription"
              ></textarea>
            </div>
          </div>
        </div>

        @if (reductionCompliantDescriptionFormControlAlertShouldBeVisible) {
          <div class="card-footer">
            <div class="alert alert-danger my-2">
              {{ 'FIELD_REQUIRED' | translate }}
            </div>
          </div>
        }
      </div>
    </section>

    <section>
      @let landParcelsChosen = areLandParcelsChosen();
      <div
        class="card mb-4"
        [ngClass]="
          submitted && !landParcelsChosen
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          {{
            'HOUSEHOLD_SEWAGE_TREATMENT_NOTIFICATION.MAP_LOCATION' | translate
          }}
        </div>

        <div class="card-body">
          <gk-map
            [mapState]="mapState"
            (dispatch)="handleMapAction($event)"
          ></gk-map>

          <div class="my-2">
            @if (mapState.mapObjectTablesState[0].mapObjects.length) {
              <gk-map-object-table
                [mapState]="mapState"
                [mapObjectTableStateIndex]="0"
                (dispatch)="handleMapAction($event)"
              ></gk-map-object-table>
            }
          </div>
        </div>
        @if (submitted && !landParcelsChosen) {
          <div class="card-footer">
            <div class="alert alert-danger mt-2">
              {{
                'HOUSEHOLD_SEWAGE_TREATMENT_NOTIFICATION.LAND_PARCEL_REQUIRED'
                  | translate
              }}
            </div>
          </div>
        }
      </div>
    </section>

    <app-proxy-details
      #proxyDetails
      [portalId]="portalId"
      [formGroup]="formGroup"
      [submitted]="submitted"
      [addressFormGroupBasedOnSelectControls]="true"
      [multiple]="true"
      [proxyTypeFormControlVisible]="true"
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
    ></app-proxy-details>

    <gk-attachments
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
      [portalId]="portalId"
      [submitted]="submitted"
      [requiredPowerOfAttorney]="proxyDetails.detailsVisible"
      [requiredOtherFile]="otherFileRequired"
    >
    </gk-attachments>

    <app-request-reply-form
      [portalId]="portalId"
      [formGroup]="formGroup"
      [submitted]="submitted"
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
    ></app-request-reply-form>

    <app-request-validation-info
      [shouldShowProvideFieldsAlert]="submitted && !isRequestValid()"
      [errorSubmitMessage]="errorSubmitMessage"
    ></app-request-validation-info>

    <section class="my-2">
      <app-cautions
        [portalId]="portalId"
        [formGroup]="formGroup"
        [submitted]="submitted"
        [borderClass]="'card-border-color-from-db'"
        [backgroundClass]="'card-header-color-from-db'"
        [buttonClass]="'btn-color-from-db'"
      ></app-cautions>
    </section>

    <section>
      <button type="submit" class="btn btn-color-from-db">
        {{ 'HOUSEHOLD_SEWAGE_TREATMENT_NOTIFICATION.SUBMIT' | translate }}
      </button>

      <app-request-preview-button
        class="ms-2"
        [buttonClass]="'btn-color-from-db'"
        [getPreviewRequestBody]="getRequestBody"
        [previewRequestUrl]="
          '/api/interesant/wniosek/zgloszenieEksploatacjiPrzydomowejOczyszczalniSciekow/podglad'
        "
      ></app-request-preview-button>

      <app-request-cancel-button></app-request-cancel-button>

      <app-doc-sign-info
        [messageText]="docSignMsgTxt"
        [messageType]="docSignMsgType"
        [docSignUrl]="docSignUrl"
        [docSignPending]="docSignPending"
      ></app-doc-sign-info>

      <div class="mt-2"><app-form-legend></app-form-legend></div>
    </section>
  </form>
</div>

<ng-template #canDeactivateModal let-close="close">
  <div class="modal-header">
    <h4 class="modal-title">
      {{ 'MODAL_CAN_DEACTIVATE.ALERT_TITLE' | translate }}
    </h4>
  </div>

  <div class="modal-body">
    {{ 'MODAL_CAN_DEACTIVATE.DESCRIPTION' | translate }}
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="close(false)">
      {{ 'MODAL_CAN_DEACTIVATE.CANCEL' | translate }}
    </button>

    <button type="button" class="btn btn-primary" (click)="close(true)">
      {{ 'MODAL_CAN_DEACTIVATE.CONFIRM' | translate }}
    </button>
  </div>
</ng-template>
